// T-199 (v1.8.70, Session 47, Kundin 13.10.2026 07:52 "warum ich die RG zu dem Gutschein nicht sehen konnte? Das ist ja im Grunde ein
// normaler Rechnungsbeleg, auf den auch die Buchhaltung Zugriff haben muss"): Gutscheinrechnungen in der Rechnungsverwaltung
// (reine Funktionen, Tests gutscheinRechnungen.test.ts). Daten aus api/invoice-archive?quelle=Gutschein.

export interface GutscheinBeleg {
  id: number;
  nummer: string;
  datum: string;
  empfaenger: string;
  bezug?: string | null;
  zahlungsart?: string | null;
  brutto: number;
  bezahlt: number;
  offen: number;
  status: string;
  bemerkung?: string | null;
}

export const GUTSCHEINRECHNUNG_HINWEIS =
  'Gutscheinrechnungen (GS-...) gehören zu Gutscheinverkäufen (Mehrzweck-Gutschein, Umsatzsteuer erst bei der Einlösung). ' +
  'Bezahlt wird eine Gutscheinrechnung über "Zahlung bestätigen" unter Gutscheine oder im Bankabgleich; damit erhält der Käufer seinen Gutschein. ' +
  'Excel-Export und PDFs aller Rechnungen eines Zeitraums: Rechnungsarchiv.';

const normal = (t: string) => t.toLowerCase().replace(/[\s-]/g, '');

/** Filter nach Suchbegriff (Rechnungsnummer auch ohne Bindestriche, Käufer, Gutschein) und Zahlstatus. */
export const filterGutscheinBelege = (belege: GutscheinBeleg[], suche: string, status: string): GutscheinBeleg[] => {
  const s = normal(suche || '');
  return belege.filter((b) => {
    if (status && b.status !== status) return false;
    if (!s) return true;
    return normal(b.nummer).includes(s) || normal(b.empfaenger || '').includes(s) || normal(b.bezug || '').includes(s);
  });
};

/** Ob ein Suchbegriff wie eine Gutscheinnummer aussieht (GS-JJJJ...), für den Hinweis unter "Rechnungen". */
export const istGutscheinNummer = (text: string): boolean => /^\s*gs[\s\-_./]*\d{4}/i.test(text || '');

/** Summen ohne stornierte Belege. */
export const summenGutscheinBelege = (belege: GutscheinBeleg[]): { brutto: number; bezahlt: number; offen: number } =>
  belege
    .filter((b) => b.status !== 'Storniert')
    .reduce((a, b) => ({ brutto: a.brutto + b.brutto, bezahlt: a.bezahlt + b.bezahlt, offen: a.offen + b.offen }), { brutto: 0, bezahlt: 0, offen: 0 });
